import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CacheService } from './cache.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AllaccessguardService {
  constructor(
    private _location: Location,
    private userService: UserService,
    private cacheService: CacheService
  ) { }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    let prime;
    let login = <boolean>await this.cacheService.getAuthentication()
    if (login) {
      await this.userService.getUser(false)
        .then(data => prime = data.isPrime)
      if (prime) {
        return true
      }
      else {
        this._location.back()
        return true
      }
    }
    else {
      return true
    }

  }
}
